import { aboutInfo } from '@/mocks/homeData';

export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="max-w-3xl mx-auto text-center">
          <span className="inline-block px-3 py-1 text-xs font-medium rounded-full bg-primary-100 text-primary-700 mb-3">
            平台简介
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-6">
            {aboutInfo.title}
          </h2>

          <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-5">
            {aboutInfo.desc1}
          </p>
          <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-10">
            {aboutInfo.desc2}
          </p>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            {aboutInfo.stats.map((s) => (
              <div key={s.label} className="p-5 rounded-xl bg-background-50 border border-background-200">
                <div className="text-2xl md:text-3xl font-bold text-primary-500 font-heading mb-1">
                  {s.value}
                </div>
                <div className="text-xs text-foreground-500">{s.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}